// HUDA PORT — section: shop — category filter.
// Ported from the static site's js/shop-filter.js (source of truth), carried
// VERBATIM: not one line of behaviour changed. The cards it filters are now
// rendered by Liquid from Shopify instead of hand-written in products.html,
// but this file never knew where they came from — it reads data-category off
// whatever .product-card elements are in the grid.
//
// Client-side only, no reload. Each pill's data-filter is matched against each
// card's data-category; «الكل» shows everything and is the default.
//
// aria-pressed is the single source of truth for pill state — hd-shop.css
// styles off the attribute, so this file never touches classes. Cards are
// toggled with the hidden attribute, which also drops them from the tab order
// and the accessibility tree (hd-shop.css supplies the display:none that the
// component's own display:flex would otherwise beat).
(function () {
  'use strict';

  var bar = document.querySelector('.hd-shop__filters');
  var grid = document.querySelector('.hd-shop__grid');
  if (!bar || !grid) return;

  var pills = bar.querySelectorAll('[data-filter]');
  var cards = grid.querySelectorAll('.product-card');
  var status = document.getElementById('shop-count');

  // Arabic counted-noun agreement — "9 منتج" is ungrammatical. 1 is singular,
  // 2 is the dual, 3–10 take the plural, 11+ take the accusative singular
  // (written bare: the alif carries it without the fathatan).
  //
  // The five forms are locale strings, handed over on the status element's
  // data attributes so the copy lives in locales/ar.json with everything else.
  // The literals below are the same strings and exist only as a fallback if
  // the markup is ever rendered without them.
  function form(name, fallback) {
    return (status && status.getAttribute('data-' + name)) || fallback;
  }

  function countLabel(n) {
    if (n === 0) return form('zero', 'لا توجد منتجات');
    if (n === 1) return form('one', 'منتج واحد');
    if (n === 2) return form('two', 'منتجان');
    if (n <= 10) return n + ' ' + form('few', 'منتجات');
    return n + ' ' + form('many', 'منتجا');
  }

  function apply(key) {
    var shown = 0;

    cards.forEach(function (card) {
      var show = key === 'all' || card.getAttribute('data-category') === key;
      card.hidden = !show;
      if (show) shown++;
    });

    // exactly one pill active at a time
    pills.forEach(function (pill) {
      pill.setAttribute('aria-pressed', pill.getAttribute('data-filter') === key ? 'true' : 'false');
    });

    // the grid changing under you is silent otherwise
    if (status) status.textContent = countLabel(shown);
  }

  pills.forEach(function (pill) {
    pill.addEventListener('click', function () {
      apply(pill.getAttribute('data-filter'));
    });
  });
})();
